import { createAction, props } from '@ngrx/store';
import { UserItem } from '../../user.model';

export const loadUserStart = createAction('LANDINGPAGE::LOAD_USER_START' ,
  props<{ email: string }>(),
  );
export const loadUserSucceeded = createAction(
    'LANDINGPAGE::LOAD_USER_SUCCEEDED',
    props<{ item: UserItem }>(),
);
export const loadUserFailed = createAction('LANDINGPAGE::LOAD_USER_FAILED', props<{ error: Error }>());
